import useSettings from "@/hook/useSettings";
import { Button, Paper, Stack,Box } from "@mui/material";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SignatureCanvas from 'react-signature-canvas'

export default function SignatureDrawing({ width, onSave }) {
  const { t } = useTranslation();
  const signatureRef = useRef();
  const [dotSize, setDotSize] = useState(5);
  const [minWidth, setMinWidth] = useState(1.25);
  const [maxWidth, setMaxWidth] = useState(5);
  const {settings} = useSettings();
  const penColor = settings.theme=="dark"?"#FFFFFF":"#000000";
  const _onClearCanvas = () => {
    signatureRef.current.clear();
  }

  const _onCanvasSave = () => {
    const base64 = signatureRef.current.toDataURL();
    onSave?.(base64);
  }

  const _setSize = (size) => {
    setDotSize(size);
    setMinWidth(size / 2 * 0.5);
    setMaxWidth(size);
  }

  return (
    <Box className={'container-wrap pup-bg-color'} sx={{ width: width + 32 }}>
      <SignatureCanvas ref={signatureRef} penColor={penColor} dotSize={dotSize} minWidth={minWidth} maxWidth={maxWidth}
        canvasProps={{width: width, height: 200, className: 'sigCanvas'}} />

      <Stack direction="row" gap={2} sx={{flexDirection:'row-reverse', paddingRight:'40px', paddingBottom:'20px'}}>
        <div onClick={() => _setSize(2)} style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{ borderRadius: '50%', width: '2px', height: '2px', backgroundColor: penColor }}></div>
        </div>
        <div onClick={() => _setSize(5)} style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{ borderRadius: '50%', width: '5px', height: '5px', backgroundColor: penColor }}></div>
        </div>
        <div onClick={() => _setSize(10)} style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{ borderRadius: '50%', width: '10px', height: '10px', backgroundColor: penColor }}></div>
        </div>
      </Stack>

      <Stack direction="row" gap={'16px'} sx={{flexDirection:'row-reverse', paddingRight:'40px'}}>
        <Button onClick={_onCanvasSave} variant="contained">
          {t('save')}
        </Button>
        <Button onClick={_onClearCanvas} variant="outlined">
          {t('rewrite')}
        </Button>
      </Stack>
    </Box>

  );
}
